/**
 * Popular filter IDs for property details
 * Array of filter IDs that should be displayed prominently
 */

export const popularFiltersIds = [25, 658, 732, 30, 60, 86, 255] as const

/** Union type of all popular filter IDs */
export type PopularFilterId = typeof popularFiltersIds[number]
// Type: 25 | 658 | 732 | 30 | 60 | 86 | 255
